import React from 'react'
import injectSheet from 'react-jss'
import TextPreview from './TextPreview'
import ImageVideoPreview from './ImageVideoPreview'
import PanoPreview from './PanoPreview'
import compose from 'recompose/compose'
import withProps from 'recompose/withProps'
import TouchTiltElement from './TouchTiltElement'

const ANIMATION_DURATION = 0.3

const style = theme => ({
    wrapper: {
        height: ({ previewType }) => previews[previewType].height,
        width: ({ previewType }) => previews[previewType].width,
        cursor: 'pointer',
        zIndex: 501,
        position: 'relative',
        animationName: ({ isVisible }) => (isVisible ? 'mountAnimation' : 'unmountAnimation'),
        animationDuration: `${ANIMATION_DURATION}s`,
        animationDelay: '0s',
        animationIterationCount: '1',
        animationTimingFunction: 'ease-out',
        animationFillMode: 'forwards',
    },
    '@keyframes mountAnimation': {
        '0%': {
            opacity: 0,
            top: 20,
        },
        '100%': {
            opacity: 1,
            top: 0,
        },
    },
    '@keyframes unmountAnimation': {
        '0%': {
            opacity: 1,
            top: 0,
        },
        '100%': {
            opacity: 0,
            top: 20,
        },
    },
})

const previews = {
    text: {
        height: 200,
        width: 400,
        component: TextPreview,
    },
    photo: {
        height: 200,
        width: 300,
        component: ImageVideoPreview,
    },
    panorama: {
        height: 244,
        width: 522,
        component: PanoPreview,
    },
    get video() {
        return previews.photo
    },
}

const props = withProps(({ onMouseLeave, onUnmount }) => ({
    handleOnMouseLeave: _ => onUnmount && onUnmount(onMouseLeave, ANIMATION_DURATION * 1000),
}))

const Preview = ({ classes, previewType, onClick, title, description, mediaUrl, handleOnMouseLeave }) => {
    const { height, width, component: Component } = previews[previewType]
    return (
        <div className={classes.wrapper} onClick={onClick} onMouseLeave={handleOnMouseLeave}>
            {previewType !== 'text' && (
                <TouchTiltElement height={height} width={width} type={previewType}>
                    <Component {...{ title, description, mediaUrl, height, width }} />
                </TouchTiltElement>
            )}
            {previewType === 'text' && (
                <Component {...{ title, description, mediaUrl, height, width }} onMouseLeave={handleOnMouseLeave} />
            )}
        </div>
    )
}

export default compose(
    injectSheet(style),
    props
)(Preview)
